module.exports = __webpack_public_path__ + "static/media/welcomeBack.8bddb114.jpg";